import { useCallback, useState } from "react";
import { SearchQueryStrings } from "@graylog/server-api";
import useUserDateTime from "hooks/useUserDateTime";
import { isNoTimeRangeOverride } from "views/typeGuards/timeRange";
import { normalizeFromSearchBarForBackend } from "views/logic/queries/NormalizeTimeRange";
const recordQueryString = async (isDirty, query) => {
  try {
    if (isDirty && !!query) {
      await SearchQueryStrings.queryStringUsed({ query_string: query });
    }
  } catch (error) {
    console.error("Unable to record last used query string: ", error);
  }
};
const _trim = (s) => s === void 0 ? void 0 : s.trim();
const useSearchBarSubmit = (initialValues, onSubmit) => {
  const { userTimezone } = useUserDateTime();
  const [enableReinitialize, setEnableReinitialize] = useState(true);
  const _onSubmit = useCallback(
    async (values) => {
      setEnableReinitialize(false);
      const { queryString, timerange, ...rest } = values;
      const trimmedQueryString = _trim(queryString);
      await recordQueryString(trimmedQueryString !== _trim(initialValues == null ? void 0 : initialValues.queryString), trimmedQueryString);
      try {
        return onSubmit({
          queryString,
          timerange: isNoTimeRangeOverride(timerange) ? void 0 : normalizeFromSearchBarForBackend(timerange, userTimezone),
          ...rest
        });
      } finally {
        setEnableReinitialize(true);
      }
    },
    [initialValues == null ? void 0 : initialValues.queryString, onSubmit, userTimezone]
  );
  return { enableReinitialize, onSubmit: _onSubmit };
};
export default useSearchBarSubmit;
